import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setLoading, setToast, clearToast } from './slices/uiSlice'
import store from './index'

export const useAppDispatch = () => useDispatch()
export const useAppSelector = useSelector

export const uiActions = { setLoading, setToast, clearToast }

// convenience utility to dispatch many actions
export const useUiActions = () => {
  const dispatch = useDispatch()
  return bindActionCreators(uiActions, dispatch)
}

export default store
